import { ERROR_CODES } from './ErrorCodes'
import { GenericServerError } from './GenericServerError'

export class RequestInvalidError extends GenericServerError {
  constructor(message?: string) {
    super({ ...ERROR_CODES.BAD_REQUEST, businessMessage: message })
  }
}
